<template>
    <div>
        <!-- modal -->
        <b-modal
            id="transferCompetition"
            size="md"
            hide-header
            hide-footer>

            <!-- Loading -->
            <b-overlay :show="form.busy || loading">

                <!-- Form -->
                <form @submit.prevent="submit" novalidate="true">

                    <!-- Field -->
                    <b-form-group :label="__('configuration.Select Competition')">
                        <select v-model="form.fk_competition" class="custom-select" :class="{ 'is-invalid': form.errors.has('fk_competition') }">
                            <option v-for="competition in competitions" :key="competition.id" :value="competition.id">{{ competition.name }}</option>
                        </select>
                        <has-error :form="form" field="fk_competition"></has-error>
                    </b-form-group>

                    <div class="d-flex align-content-center justify-content-between">

                        <!-- Submit -->
                        <b-button type="submit" variant="primary" :disabled="form.busy">
                            {{ __('configuration.Migrate Now') }}
                        </b-button>

                    </div>

                </form>
            </b-overlay>

        </b-modal>
    </div>
</template>

<script>
import { Form } from "vform";

export default {
    props: ['locale', 'currency'],
    data() {
        return {
            loading: false,
            form: new Form({
                fk_user_competition: null,
                fk_competition: null,
            }),
            competitions: [],
        }
    },
    created() {
        this.$root.$on('transferCompetition', (fk_user_competition) => {
            this.loadCompetitions();

            this.form = new Form({
                fk_user_competition: fk_user_competition,
                fk_competition: null,
            })

            this.$bvModal.show('transferCompetition')
        })
    },
    methods: {

        loadCompetitions() {
            this.loading = true
            axios.get('/' + this.locale +'/configurations/competitions/transfer')
                .then((result) => {
                    this.competitions = result
                })
                .finally(() => this.loading = false)
        },

        submit() {
            this.form.put('/' + this.locale + '/configurations/competitions/transfer')
                .then(result => {

                    this.$toast.success(result.message)

                    this.$emit('updated')

                    this.$bvModal.hide('transferCompetition')
                })
        },

    }
}
</script>

<style scoped>

</style>
